import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { SharedModule } from '../shared/shared.module';
import { AuthGuardService } from '../shared/services/auth-guard.service';
import {DenyNonStaffService} from "../shared/services/deny-non-staff.service";
import {CutlogComponent} from './cutlog.component';
import {ReportsService} from './reports.service';
import {SortCutPipe} from './pipes/sort-cut-pipe'
import {DeliveriesComponent} from './deliveries.component';
import {HcustomerComponent} from './hcustomer.component';
import {HestimateComponent} from './hestimate.component';
import {SawTimePipe} from './pipes/saw-time-pipe';



@NgModule({
  imports: [
    SharedModule,
    RouterModule.forChild([
      { path: 'reports/cutlog', component: CutlogComponent, canActivate: [AuthGuardService, DenyNonStaffService] },
      { path: 'reports/deliveries', component: DeliveriesComponent, canActivate: [AuthGuardService, DenyNonStaffService] },
      { path: 'reports/hold/customer', component: HcustomerComponent, canActivate: [AuthGuardService, DenyNonStaffService] },
      { path: 'reports/hold/estimating', component: HestimateComponent, canActivate: [AuthGuardService, DenyNonStaffService] }
    ])
  ],
  providers: [
    ReportsService
  ],
  declarations: [
    CutlogComponent,
    DeliveriesComponent,
    HcustomerComponent,
    HestimateComponent,
    SortCutPipe,
    SawTimePipe
  ]
})
export class ReportsModule { }



// WEBPACK FOOTER //
// ./src/app/reports/reports.module.ts